var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 6.66667H8.0013C7.2513 6.66667 6.66797 7.29167 6.66797 8.00001V24C6.66797 24.75 7.2513 25.3333 8.0013 25.3333H24.0013C24.7096 25.3333 25.3346 24.75 25.3346 24V8.00001C25.3346 7.29167 24.7096 6.66667 24.0013 6.66667ZM23.3346 23.3333H8.66797V20.6667H23.3346V23.3333ZM23.3346 18.6667H22.668L18.5846 13.625C18.293 13.25 17.668 13.25 17.3763 13.625L14.7096 16.9167L13.3346 15.0417C13.0013 14.5833 12.293 14.5833 11.9596 15.0417L9.33464 18.6667H8.66797V8.66667H23.3346V18.6667ZM12.668 12.6667C13.3763 12.6667 14.0013 12.0833 14.0013 11.3333C14.0013 10.625 13.3763 10 12.668 10C11.918 10 11.3346 10.625 11.3346 11.3333C11.3346 12.0833 11.918 12.6667 12.668 12.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e6be5008852c485cf18a23fce9c5eec7.svg";
export { ForwardRef as ReactComponent };